/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// @mui icons

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation('common');
    const currentYear = new Date().getFullYear();
    const version = window?.appConfig?.REACT_APP_SOFTWARE_VERSION || process.env.REACT_APP_SOFTWARE_VERSION;
    return (
        <SoftBox component="footer" py={6}>
            <Grid container justifyContent="center">
                <Grid item xs={12} lg={8} sx={{ textAlign: "center" }}>
                    <SoftTypography variant="body2" color="secondary">
                        {t("general.copyright", { year: currentYear })}
                    </SoftTypography>
                    <SoftTypography variant="body2" color="secondary">
                        {t("general.version", { version })}
                    </SoftTypography>
                </Grid>
            </Grid>
        </SoftBox>
    );
}

export default Footer;
